module.exports = __webpack_public_path__ + "1d60917864238705a245265a3be0661e.png";